import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import TextOval from "components/TextOval";
import ToggleSwitch from "components/ToggleSwitch";
import Select from "components/Select";

import './themes/default.less';
import './index.less';

const paths = {
    18: { path: "adult/18_S", size: 72 },
    17: { path: "adult/17_S", size: 70 },
    16: { path: "adult/16_S", size: 73 },
    15: { path: "adult/15_S", size: 77 },
    14: { path: "adult/14_S", size: 77 },
    13: { path: "adult/13_S", size: 77 },
    12: { path: "adult/12_S", size: 70 },
    11: { path: "adult/11_S", size: 73 },
    21: { path: "adult/21_S", size: 73 },
    22: { path: "adult/22_S", size: 70 },
    23: { path: "adult/23_S", size: 77 },
    24: { path: "adult/24_S", size: 77 },
    25: { path: "adult/25_S", size: 77 },
    26: { path: "adult/26_S", size: 73 },
    27: { path: "adult/27_S", size: 70 },
    28: { path: "adult/28_S", size: 72 },

    48: { path: "adult/48_S", size: 75 },
    47: { path: "adult/47_S", size: 82 },
    46: { path: "adult/46_S", size: 82 },
    45: { path: "adult/45_S", size: 79 },
    44: { path: "adult/44_S", size: 70 },
    43: { path: "adult/43_S", size: 69 },
    42: { path: "adult/42_S", size: 64 },
    41: { path: "adult/41_S", size: 64 },
    31: { path: "adult/31_S", size: 64 },
    32: { path: "adult/32_S", size: 64 },
    33: { path: "adult/33_S", size: 69 },
    34: { path: "adult/34_S", size: 70 },
    35: { path: "adult/35_S", size: 79 },
    36: { path: "adult/36_S", size: 82 },
    37: { path: "adult/37_S", size: 82 },
    38: { path: "adult/38_S", size: 75 },

    55: { path: "children/55_S", size: 77 },
    54: { path: "children/54_S", size: 77 },
    53: { path: "children/53_S", size: 77 },
    52: { path: "children/52_S", size: 70 },
    51: { path: "children/51_S", size: 73 },
    61: { path: "children/61_S", size: 73 },
    62: { path: "children/62_S", size: 70 },
    63: { path: "children/63_S", size: 77 },
    64: { path: "children/64_S", size: 77 },
    65: { path: "children/65_S", size: 77 },

    85: { path: "children/85_S", size: 79 },
    84: { path: "children/84_S", size: 70 },
    83: { path: "children/83_S", size: 69 },
    82: { path: "children/82_S", size: 64 },
    81: { path: "children/81_S", size: 64 },
    71: { path: "children/71_S", size: 64 },
    72: { path: "children/72_S", size: 64 },
    73: { path: "children/73_S", size: 69 },
    74: { path: "children/74_S", size: 70 },
    75: { path: "children/75_S", size: 79 },
};

export default class DentalFormula extends MainComponent {

    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            babyTeeth: false,
            selected: [],
        };
    }

    static propTypes = {
        diagnosisTeeth: PropTypes.object,
        teeth: PropTypes.array,
        showBite: PropTypes.bool,
        showTeeth: PropTypes.bool,
        choiceDiagnosis: PropTypes.bool,
        onChangeTeeth: PropTypes.func,
        onChangeDiagnosis: PropTypes.func,
        showOralJaw: PropTypes.bool,
        onChangeOcclusion: PropTypes.func,
        occlusion: PropTypes.string,
    };
    static defaultProps = {
        diagnosisTeeth: {},
        teeth: [],
        showBite: false,
        showTeeth: false,
        choiceDiagnosis: false,
        onChangeTeeth: null,
        onChangeDiagnosis: null,
        showOralJaw: true,
        onChangeOcclusion: null,
        occlusion: "",
    };

    componentDidMount() {
        if (this.props.occlusion !== null)
            this.occlusion = this.props.occlusion;
    }
    componentDidUpdate() {
        if (this.props.occlusion !== null)
            this.occlusion = this.props.occlusion;
    }

    setTeeth(selected) {
        this.setState({ selected });
    }

    getDiagStr(i) {
        const { diagnosisTeeth } = this.props;

        if (diagnosisTeeth[i] && Array.isArray(diagnosisTeeth[i])) {
            const diag = diagnosisTeeth[i].map(it => it.abb).join(',');
            return diag;
        }

        return "";
    }

    getTextTeeth() {
        const { selected } = this.state;
        return this._helper.getTeethNames(selected).join(", ");
    }

    onClickTeeth(id) {
        let { babyTeeth, selected } = this.state;
        const { diagnosisTeeth, onChangeTeeth, onChangeDiagnosis, choiceDiagnosis } = this.props;
        const excludeTeeth = [100, 101, 102];

        if (selected.includes(id))
            selected = selected.filter(it => it !== id);
        else {
            selected = [...selected, id];

            if (choiceDiagnosis && !excludeTeeth.includes(id))
                globalThis.appPageView.openDialog("teeth", babyTeeth, id, diagnosisTeeth[id], onChangeDiagnosis);
        }

        this.setState({ selected }, () => {
            if (onChangeTeeth?.apply)
                onChangeTeeth([...selected]);
        });
    }

    onChangeOcclusion(id) {
        if (this.props.onChangeOcclusion?.apply)
            this.props.onChangeOcclusion(id);
    }

    renderTeeth(begin, end) {
        const { selected } = this.state;
        const teeth = [];

        for (let i = begin; begin > end ? i >= end : i <= end; begin > end ? i-- : i++) {
            teeth.push(
                <div key={i} className="flex col centerH gap8" onClick={this.onClickTeeth.bind(this, i)}>
                    <div className={`contTeeth pos rel flex centerH endV ${selected.includes(i) ? "selected" : ""}`}>
                        <img
                            className="pos abs sideAll"
                            src={`/img/${paths[i].path}.png`}
                            alt={`teeth ${i}`}
                        />
                    </div>
                    <div className="legend text p1 flex centerH">{i}</div>
                    <div className="diagnosis text p1 flex centerH">{this.getDiagStr(i)}</div>
                </div>
            );
        }
        return teeth;
    }

    renderRowInfo(title, value) {
        const val = value ? value : "main.choose";
        return (
            <div className="rowInfo text p1 flex gap16">
                <div className="rowInfoTitle">{this.tr(title)}</div>
                <div className={`rowInfoValue hand ${value ? "" : "choose"}`}>
                    {this.tr(val)}
                </div>
            </div>
        );
    }

    renderRowText(rowText) {
        return (
            <div className="rowText text p2">
                {this.tr(rowText)}
            </div>
        );
    }

    renderBite() {
        const occlusionList = this._config.occlusion;

        return (
            <div className="flex col gap8" style={{ width: "210px" }}>
                {this.renderRowText("client.bite")}
                <Select
                    itemStyle="flex1"
                    value={this.occlusion}
                    translate={true}
                    showLeftIcon={false}
                    placeHolder="main.notIndicated"
                    items={occlusionList}
                    onChange={this.onChangeOcclusion.bind(this)}
                />
            </div>
        );
    }

    render() {
        const { babyTeeth, selected } = this.state;
        const { showTeeth, showBite, showOralJaw } = this.props;

        return (
            <div className="dentalFormula flex col gap16">
                <div className="flex between">
                    {showTeeth ? this.renderRowInfo(this._helper.string.capitalize(this.tr("client.teeth")), this.getTextTeeth()) :
                        showBite ? this.renderBite() : <div></div>}
                    <div>
                        <ToggleSwitch
                            checked={babyTeeth}
                            label="client.showBabyTeeth"
                            onChange={this.toggleState.bind(this, "babyTeeth")}
                        />
                    </div>
                </div>
                {showTeeth && showBite && this.renderBite()}
                <div className="flex col gap16">
                    {!babyTeeth && <div className="flex gap8">
                        {this.renderTeeth(18, 11)}
                        {this.renderTeeth(21, 28)}
                    </div>}
                    {babyTeeth && <div className="flex gap8 centerH" style={{ width: "920px" }}>
                        {this.renderTeeth(55, 51)}
                        {this.renderTeeth(61, 65)}
                    </div>}
                    {babyTeeth && <div className="flex gap8 centerH" style={{ width: "920px" }}>
                        {this.renderTeeth(85, 81)}
                        {this.renderTeeth(71, 75)}
                    </div>}
                    {!babyTeeth && <div className="flex gap8">
                        {this.renderTeeth(48, 41)}
                        {this.renderTeeth(31, 38)}
                    </div>}
                    {showOralJaw && <div className="flex centerH">
                        <div className="flex gap16">
                            <TextOval
                                text="client.oralCavity"
                                select={selected.includes(100)}
                                onClick={this.onClickTeeth.bind(this, 100)}
                            />
                            <TextOval
                                text="client.lowerJaw"
                                select={selected.includes(101)}
                                onClick={this.onClickTeeth.bind(this, 101)}
                            />
                            <TextOval
                                text="client.upperJaw"
                                select={selected.includes(102)}
                                onClick={this.onClickTeeth.bind(this, 102)}
                            />
                        </div>
                    </div>}
                </div>
            </div>
        );
    }
}
